<template>
  <div v-if="isFree && !isDemoPage">
    <v-tooltip bottom>
      <template #activator="{ props }">
        <v-icon v-bind="props" class="ml-2">mdi-star</v-icon>
      </template>
      <span>{{ message }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useAuthStore } from '@/store';
import { useRoute } from 'vue-router';

export default {
  name: 'PremiumFeatureIcon',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  setup() {
    const authStore = useAuthStore();
    const route = useRoute();
    const isFree = computed(() => authStore.user?.role === 'free');
    const isDemoPage = computed(() => route.name === 'Aquarium Demo');
    return { isFree, isDemoPage };
  },
};
</script>